/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressDtoFromJSON, AddressDtoToJSON, } from './AddressDto';
import { BountyLocationFromJSON, BountyLocationToJSON, } from './BountyLocation';
import { IncidentReportTypeFromJSON, IncidentReportTypeToJSON, } from './IncidentReportType';
/**
 * Check if a given object implements the BountyDto interface.
 */
export function instanceOfBountyDto(value) {
    let isInstance = true;
    return isInstance;
}
export function BountyDtoFromJSON(json) {
    return BountyDtoFromJSONTyped(json, false);
}
export function BountyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'location': !exists(json, 'location') ? undefined : BountyLocationFromJSON(json['location']),
        'address': !exists(json, 'address') ? undefined : AddressDtoFromJSON(json['address']),
        'windowStartDateTime': !exists(json, 'windowStartDateTime') ? undefined : (json['windowStartDateTime'] === null ? null : new Date(json['windowStartDateTime'])),
        'windowEndDateTime': !exists(json, 'windowEndDateTime') ? undefined : (json['windowEndDateTime'] === null ? null : new Date(json['windowEndDateTime'])),
        'windowTimezone': !exists(json, 'windowTimezone') ? undefined : json['windowTimezone'],
        'incidentReportType': !exists(json, 'incidentReportType') ? undefined : IncidentReportTypeFromJSON(json['incidentReportType']),
        'requestDescription': !exists(json, 'requestDescription') ? undefined : json['requestDescription'],
        'rewardAmountPoints': !exists(json, 'rewardAmountPoints') ? undefined : json['rewardAmountPoints'],
        'expiresAt': !exists(json, 'expiresAt') ? undefined : (new Date(json['expiresAt'])),
        'isClaimed': !exists(json, 'isClaimed') ? undefined : json['isClaimed'],
    };
}
export function BountyDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'countryCode': value.countryCode,
        'location': BountyLocationToJSON(value.location),
        'address': AddressDtoToJSON(value.address),
        'windowStartDateTime': value.windowStartDateTime === undefined ? undefined : (value.windowStartDateTime === null ? null : value.windowStartDateTime.toISOString()),
        'windowEndDateTime': value.windowEndDateTime === undefined ? undefined : (value.windowEndDateTime === null ? null : value.windowEndDateTime.toISOString()),
        'windowTimezone': value.windowTimezone,
        'incidentReportType': IncidentReportTypeToJSON(value.incidentReportType),
        'requestDescription': value.requestDescription,
        'rewardAmountPoints': value.rewardAmountPoints,
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
        'isClaimed': value.isClaimed,
    };
}
